/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const MenuAfterpay: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M21.25 17.5C21.3881 17.5 21.5 17.6119 21.5 17.75V20.25C21.5 20.3881 21.3881 20.5 21.25 20.5H2.75C2.61193 20.5 2.5 20.3881 2.5 20.25V17.75C2.5 17.6119 2.61193 17.5 2.75 17.5H21.25ZM21.25 10.5C21.3881 10.5 21.5 10.6119 21.5 10.75V13.25C21.5 13.3881 21.3881 13.5 21.25 13.5H2.75C2.61193 13.5 2.5 13.3881 2.5 13.25V10.75C2.5 10.6119 2.61193 10.5 2.75 10.5H21.25ZM21.25 3.5C21.3881 3.5 21.5 3.61193 21.5 3.75V6.25C21.5 6.38807 21.3881 6.5 21.25 6.5H2.75C2.61193 6.5 2.5 6.38807 2.5 6.25V3.75C2.5 3.61193 2.61193 3.5 2.75 3.5H21.25Z'
      fill='currentColor'
    />
  </React.Fragment>
)
